import './Finish.css';
import { Button, Grid, TextArea, Popup } from 'semantic-ui-react';
import { useEffect, useState } from 'react';
import { api } from '../../../../utils/api';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import ru from 'date-fns/locale/ru';
import { toast } from 'react-toastify';
import { formatDateToDateTime, formatDateDescription } from '../../../../utils/helpers/dateHelpers';
import CustomDropdown from '../../../../shared/CustomDropdown/CustomDropdown';
import { format } from 'date-fns';

export default function Finish({ data, setData, onClickBack, onFinish }) {
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [dateDescription, setDateDescription] = useState(null);
  const [comment, setComment] = useState('');
  const [employees, setEmployees] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSchedule, setHasSchedule] = useState(false);

  // useEffects

  useEffect(() => {
    loadEmployees();
  }, [selectedDay]);

  useEffect(() => {
    const dealerPointId = data.dialerId;

    if (!dealerPointId || !selectedDay || !selectedEmployeeId) {
      return;
    }
    const wishDateFormatted = format(selectedDay, 'dd.MM.yyyy', { locale: ru });

    loadTimeSlots(dealerPointId, wishDateFormatted, selectedEmployeeId);
  }, [selectedEmployeeId]);

  // Handlers

  const handleDateSelect = val => {
    const now = new Date();
    now.setMilliseconds(0);
    now.setSeconds(0);
    now.setHours(0);
    now.setMinutes(0);

    const before = new Date();
    before.setDate(before.getDate() + 7);

    if (val < now) {
      toast.error('Выберите дату в будущем');
      setSelectedDay(null);
      setSelectedTimeSlot(null);
      setDateDescription(null);
      return;
    }

    if (val > before) {
      toast.error('Выберите дату ранее ' + before.toLocaleDateString());
      setSelectedDay(null);
      setSelectedTimeSlot(null);
      setDateDescription(null);
      return;
    }

    setSelectedDay(val);
    setSelectedTimeSlot(null);
    setDateDescription(null);
    setSelectedEmployeeId(null);
    setTimeSlots([]);
  };

  const handleReset = () => {
    setHasSchedule(false);
    setEmployees([]);
    setTimeSlots([]);
    setSelectedEmployeeId(null);
    setSelectedTimeSlot(null);
  };

  const loadEmployees = async () => {
    if (!selectedDay) {
      handleReset();
      return;
    }

    try {
      const wishDateFormatted = format(selectedDay, 'dd.MM.yyyy', { locale: ru });
      const response = await api().getServiceConsultantsEmpList(data.dialerId, wishDateFormatted);

      const hasSchedule = response?.HasSchedule ?? false;
      const employeesList = response?.Employees ?? [];

      setHasSchedule(hasSchedule);

      if (hasSchedule && employeesList.length > 0) {
        const empList = employeesList.map(emp => ({
          id: emp.Id,
          name: emp.Descr,
        }));
        setEmployees(empList);
      } else {
        setEmployees([]);
        setTimeSlots([]);
        setSelectedEmployeeId(null);
        setSelectedTimeSlot(null);
      }
    } catch (error) {
      handleReset();
    }
  };

  const loadTimeSlots = async (dealerPointId, wishDate) => {
    if (!dealerPointId || !wishDate || !selectedEmployeeId) {
      return;
    }

    setLoading(true);

    try {
      const response = await api().getTimeSlots(dealerPointId, wishDate, selectedEmployeeId);
      if (response && Array.isArray(response)) {
        const slots = response.map(slot => ({
          timeSlot: slot.TimeSlot.slice(0, -3),
          isBusy: slot.IsBusy,
        }));
        setTimeSlots(slots);
      } else {
        setTimeSlots([]);
      }
    } catch (error) {
      setTimeSlots([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEmployeeSelect = empId => {
    setSelectedEmployeeId(empId);
    setSelectedTimeSlot(null);
  };

  const handleTimeSlotSelect = timeSlot => {
    setSelectedTimeSlot(timeSlot);
    const dateDescription = formatDateDescription(selectedDay, timeSlot);
    setDateDescription(dateDescription);
    setData(data => {
      data.date = dateDescription;
      return data;
    });
  };

  const handleCommentChange = e => {
    setComment(e.target.value);
  };

  const isTimeSlotAvailable = timeSlot => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (today - selectedDay === 0) {
      const [hours, minutes] = timeSlot.split(':').map(parseInt);
      const target = new Date();
      target.setHours(hours, minutes, 0, 0);
      return new Date() < target;
    }

    return true;
  };

  const createRequest = () => {
    const engineData = data.filter(x => x.name === 'engine')[0];
    const additionalWorksIds = data.additionalWorks
      .filter(x => x.added)
      .map(x => x.WorkId)
      .reduce((acc, id, idx, arr) => acc + (idx > 0 ? ',' : '') + id, '');

    const order = {
      dealerPointId: data.dialerId,
      clientDescr: data.name + ' ' + data.lastName,
      phone: data.phone,
      email: data.email,
      familyId: data.filter(x => x.name === 'car')[0].familyId,
      versionId: engineData.type,
      carTypeId: 201,
      licensePlate: data.carNumber,
      vin: data.carVin,
      orderDatetime: formatDateToDateTime(selectedDay, selectedTimeSlot),
      serviceBookId: engineData.serviceBookId,
      serviceBookColumnId: engineData.serviceBookColumnId,
      price: data.totalPrice,
      additionalWorks: additionalWorksIds,
      notes: comment,
      wishEmpId: selectedEmployeeId,
    };

    api()
      .createMaintenanceOrder(order)
      .then(() => {
        onFinish();
      });
  };

  // Renders

  const renderTitle = () => {
    if (selectedDay === null && selectedTimeSlot === null) {
      return;
    }
    return <div>Дата и время Вашего визита на сервисное обслуживание</div>;
  };

  const renderButton = () => {
    const isDisabled = !selectedDay || !selectedTimeSlot;

    return (
      <button className={'create-request'} onClick={createRequest} disabled={isDisabled}>
        записаться на сервис
      </button>
    );
  };

  const renderComment = () => {
    return (
      <>
        <TextArea
          value={comment}
          onChange={handleCommentChange}
          className={'comment-input'}
          placeholder={'Ваш комментарий'}
        />
        <span className={'text-date-description'}>{dateDescription}</span>
      </>
    );
  };

  const renderTimeSlots = () => {
    if (selectedDay === null) {
      return;
    }

    if (!hasSchedule) {
      return (
        <>
          <div>Доступные временные интервалы</div>
          <div className={'time-slots'}>
            {data.calculation.TimeRecords.filter(isTimeSlotAvailable).map(timeSlot => (
              <div
                key={timeSlot}
                className={selectedTimeSlot === timeSlot ? 'selected' : ''}
                onClick={() => handleTimeSlotSelect(timeSlot)}
              >
                {timeSlot.substr(0, 5)}
              </div>
            ))}
          </div>
          {renderComment()}
        </>
      );
    }

    return (
      <>
        {loading ? <div>Загрузка...</div> : ''}
        {!loading && selectedEmployeeId !== null && !!timeSlots.length && (
          <>
            <div>Доступные временные интервалы</div>
            <div className={'time-slots'}>
              {timeSlots.map(slot =>
                slot.isBusy ? (
                  <Popup
                    trigger={
                      <div
                        className={`${selectedTimeSlot === slot.timeSlot ? 'selected' : ''} ${
                          slot.isBusy ? 'disabled' : ''
                        }`}
                      >
                        {slot.timeSlot}
                      </div>
                    }
                    content='Время недоступно'
                    position='bottom center'
                    size='mini'
                  />
                ) : (
                  <div
                    className={`${selectedTimeSlot === slot.timeSlot ? 'selected' : ''}`}
                    onClick={() => handleTimeSlotSelect(slot.timeSlot)}
                  >
                    {slot.timeSlot}
                  </div>
                )
              )}
            </div>
          </>
        )}
        {renderComment()}
      </>
    );
  };

  return (
    <div className={'select-time-slot-page'}>
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <div style={{ paddingLeft: '20px' }}>Выберите дату</div>
            <div className={'calendar'}>
              <DayPicker
                disabledDays={{
                  after: new Date(),
                }}
                locale={ru}
                mode='single'
                selected={selectedDay}
                onSelect={handleDateSelect}
              />
              {!!employees.length && (
                <>
                  <div style={{ paddingBottom: '10px' }}>Выберите сотрудника</div>
                  <CustomDropdown
                    value={selectedEmployeeId}
                    onChange={handleEmployeeSelect}
                    label='Сотрудник'
                    options={employees}
                    disabled={!employees.length}
                  />
                </>
              )}
            </div>

            {renderTitle()}
          </Grid.Column>
          <Grid.Column width={8}>{renderTimeSlots()}</Grid.Column>
        </Grid.Row>
      </Grid>
      {renderButton()}
      <Grid.Row className={'actions-container'}>
        <Grid.Column width={8}>
          <Button onClick={onClickBack}>Вернуться</Button>
        </Grid.Column>
        <Grid.Column width={8}></Grid.Column>
      </Grid.Row>
    </div>
  );
}
